<template>
    <footer>
        <div class="container-fluid">
            <div class="d-flex flex-column justify-content-center text-center">
                <p>{{ this.$strings.us }}<br/>
                <a href="public/docs/privacy_1_sim.pdf" target="_blank">Privacy</a> | <a v-b-modal.modal-cookie-policy>Cookie Policy</a> | <a v-b-modal.modal-legal-info>Legal Information</a></p>
            </div>            
        </div>
        <CookiePolicy/>
        <LegalInfo/>
    </footer>
</template>

<script>
import CookiePolicy from '@/components/modals/CookiePolicy.vue'
import LegalInfo from '@/components/modals/LegalInfo.vue'


export default {
    components: {
        CookiePolicy,
        LegalInfo
	}
}
</script>